import { render } from "./StockAdjustment.vue?vue&type=template&id=8ea544ba"
import script from "./StockAdjustment.vue?vue&type=script&lang=js"
export * from "./StockAdjustment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/StockAdjustment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8ea544ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8ea544ba', __exports__)) {
    api.reload('8ea544ba', __exports__)
  }
  
  module.hot.accept("./StockAdjustment.vue?vue&type=template&id=8ea544ba", () => {
    api.rerender('8ea544ba', render)
  })

}


export default __exports__